const DOCS_ROOT = "https://docs.loopscale.com";

export const DOCS = {
    root: DOCS_ROOT,
    borrowTutorial: `${DOCS_ROOT}/using-loopscale/borrow/overview`,
    lendTutorial: `${DOCS_ROOT}/using-loopscale/lend/advanced-lend`,
    earnVaultTutorial: `${DOCS_ROOT}/using-loopscale/earn-vaults`,
    loopTutorial: `${DOCS_ROOT}/using-loopscale/loop`,
    manualLoopTutorial: `${DOCS_ROOT}/using-loopscale/loop#manually-open`,
    manualLoopClose: `${DOCS_ROOT}/using-loopscale/loop#manually-close`,
    lendVaultTutorial: `${DOCS_ROOT}/protocol-concepts/loopscale-vaults`,
    pointsTutorial: `${DOCS_ROOT}/using-loopscale/points`
};
